import { render, staticRenderFns } from "./SearchArticleCardList.vue?vue&type=template&id=6945b2d4&scoped=true&"
import script from "./SearchArticleCardList.vue?vue&type=script&lang=js&"
export * from "./SearchArticleCardList.vue?vue&type=script&lang=js&"
import style0 from "./SearchArticleCardList.vue?vue&type=style&index=0&id=6945b2d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6945b2d4",
  null
  
)

export default component.exports